/**
 * F2e — Payments FE wrapper.
 *
 * BE route-ok:
 *   GET    /groups/:id/payments?targetId=&requirementId=&fromDate=&toDate=
 *   GET    /targets/:id/payments
 *   GET    /payments/:id
 *   POST   /groups/:id/payments
 *   PATCH  /payments/:id
 *   DELETE /payments/:id
 */

import type {
  Payment,
  PaymentCreateInput,
  PaymentUpdateInput,
} from '@pta/types';
import { apiCall } from './client';

export interface PaymentsListParams {
  targetId?: number;
  requirementId?: number;
  fromDate?: string;
  toDate?: string;
  limit?: number;
  offset?: number;
}

export function fetchGroupPayments(
  groupId: number,
  params?: PaymentsListParams,
): Promise<Payment[]> {
  return apiCall(`/groups/${groupId}/payments`, {
    query: {
      targetId: params?.targetId,
      requirementId: params?.requirementId,
      fromDate: params?.fromDate,
      toDate: params?.toDate,
      limit: params?.limit,
      offset: params?.offset,
    },
  });
}

export function fetchTargetPayments(targetId: number): Promise<Payment[]> {
  return apiCall(`/targets/${targetId}/payments`);
}

export function fetchPayment(id: number): Promise<Payment> {
  return apiCall(`/payments/${id}`);
}

export function createPayment(
  groupId: number,
  input: PaymentCreateInput,
): Promise<Payment> {
  return apiCall(`/groups/${groupId}/payments`, {
    method: 'POST',
    body: input,
  });
}

export function updatePayment(
  id: number,
  input: PaymentUpdateInput,
): Promise<Payment> {
  return apiCall(`/payments/${id}`, { method: 'PATCH', body: input });
}

export function deletePayment(id: number): Promise<Payment> {
  return apiCall(`/payments/${id}`, { method: 'DELETE' });
}
